import { MessageBox as ElMessageBox }          from 'element-ui';
import { ElMessageBoxOptions, MessageBoxData } from 'element-ui/types/message-box';
import i18n                                    from '@/i18n';

interface MessageBox {
  baseParams: Partial<ElMessageBoxOptions>;
  confirm: (message: string, title: string, customConfig: Partial<ElMessageBoxOptions>) => void;
  prompt: (message: string, title: string, customConfig?: Partial<ElMessageBoxOptions>) => Promise<MessageBoxData>;
}

export const MessageBox: MessageBox = {
  baseParams: {
    closeOnPressEscape: true,
  },
  confirm(message: string, title: string, customConfig: Partial<ElMessageBoxOptions> = {}) {
    const config: ElMessageBoxOptions = {
      ...this.baseParams,
      customClass: 'el-message-box--confirm',
      confirmButtonText: i18n.t('__global__.buttons.confirm').toString(),
      confirmButtonClass: 'confirm-button',
      cancelButtonText: i18n.t('__global__.buttons.cancel').toString(),
      closeOnClickModal: false,
      ...customConfig,
    };
    return ElMessageBox.confirm(message, title, config);
  },
  prompt(message: string, title: string, customConfig: Partial<ElMessageBoxOptions> = {}) {
    const config: ElMessageBoxOptions = {
      ...this.baseParams,
      customClass: 'el-message-box--confirm',
      confirmButtonText: i18n.t('__global__.buttons.confirm').toString(),
      confirmButtonClass: 'confirm-button',
      cancelButtonText: i18n.t('__global__.buttons.cancel').toString(),
      closeOnClickModal: false,
      ...customConfig,
    };
    return ElMessageBox.prompt(message, title, config);
  },
};
